module.exports = __webpack_public_path__ + "static/sport/pc-down-btn-bg.180654f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport7/pc-down-btn-bg.png
// module id = l+jI
// module chunks = 0